import React, { useEffect } from 'react';
import Table from '../components/Table/Table';
import { useDispatch, useSelector } from 'react-redux';
import useViewVisited from '../features/app/hooks/useViewVisted';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';
import FileOpenIcon from '@material-ui/icons/OpenInNew';
import { Tooltip, IconButton } from '@material-ui/core';
import {
  getInteractionMarketListReport,
  getIsFetchingEngagementReportMarketList,
  getPpsisReviewSummary,
  isFetchingSummary
} from 'features/PpsiContainer/selectors';
import {
  fetchCoWorkerEngagementReportMarketList,
  fetchPpsisReviewSummary
} from 'features/PpsiContainer/actions';
import { toJS } from '../utils/immutableUtils';
import { coWorkerEngagementReportRoute, globalMarketReviewRoute } from 'routes';
import ProgressFullscreen from 'components/common/ProgressFullscreen';
import useMarketLabel from 'features/app/hooks/useMarketLabel';
import { getMarketName } from 'features/app/selectors';

const CoWorkerEngagementReportListView = () => {
  const totalEngagementReportMarketList = useSelector(
    getInteractionMarketListReport
  );
  const interactionMarketList = toJS(totalEngagementReportMarketList, []);
  const isFetchingEngagementReport = useSelector(
    getIsFetchingEngagementReportMarketList
  );

  const dispatch = useDispatch();
  const currOrganization = useSelector(getMarketName);

  useEffect(() => {
    dispatch(fetchCoWorkerEngagementReportMarketList(currOrganization));
  }, []);

  if (isFetchingEngagementReport) {
    return <ProgressFullscreen open />;
  }

  const GlobalReviewColumns = {
    MarketName: {
      name: 'displayLabel',
      label: 'Market Name',
      dataField: 'displayLabel',
      sortable: true,
      width: 200,
      grow: 0,
      shrink: 0
    },
    MarketCode: {
      name: 'countryCode',
      dataField: 'countryCode',
      sortable: false,
      label: 'Code',
      width: 120,
      grow: 0,
      shrink: 0
    },
    // Numbers: {
    //   name: 'NoofObjects',
    //   dataField: 'NoofObjects',
    //   //   filterable: true,
    //   sortable: false,
    //   label: 'Total Review Pending',
    //   width: 180,
    //   grow: 0,
    //   shrink: 0
    // },
    PreviewActions: {
      name: 'action',
      label: 'Actions',
      CellValue: ({ rowData }) => {
        return (
          <Tooltip title={`Go to ${rowData.countryCode} market`}>
            <IconButton
              onClick={() => {
                //  return checkOutToMarket(rowData.market)
              }}
              color="secondary"
              size="medium"
            >
              <FileOpenIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        );
      },
      link: rowData => coWorkerEngagementReportRoute(rowData.countryCode),
      grow: 0,
      shrink: 0,
      width: 45,
      sortable: false,
      searchable: false
    },
    EmptySpace: {
      name: 'itemCode',
      dataField: 'itemCode',
      sortable: false,
      label: '  '
    }
  };

  return (
    <>
      <PaperContainer>
        <Table
          title="coworkerEngagementReport.enangementReportTitle"
          // title="updatesList.updatesTableHeader"
          data={interactionMarketList}
          columns={[
            GlobalReviewColumns.MarketName,
            GlobalReviewColumns.MarketCode,
            // GlobalReviewColumns.Numbers,
            GlobalReviewColumns.PreviewActions,
            GlobalReviewColumns.EmptySpace
          ]}
          getObjectId={object => object.id}
          defaultSorting={[{ columnName: 'market', direction: 'asc' }]}
          selectable
        />
      </PaperContainer>
    </>
  );
};

export default CoWorkerEngagementReportListView;
